<mat-card class="car-card" [routerLink]="['/cars', car.car_id]">
  <mat-card-content class="car-content">
    <div class="car-title-row">
        <div class="car-detail">
            <span class="car-title">{{ car.car_title }}</span>
            <span class="car-plate" *ngIf="car.license_plate">{{ car.license_plate }}</span>
        </div>
      <mat-chip-set class="car-chip">
        <mat-chip [class]="'status-chip status-' + car.status" selected>
          {{ car.status | statusLabel:'availability' }}
        </mat-chip>
      </mat-chip-set>
    </div>
  </mat-card-content>
</mat-card>
